import React from 'react';
import { List, ListItem } from 'common/components/list';
import { TypographyTextProps } from 'common/components/typography';
import { createElementKey } from 'utils';
import { bannerList } from './banner-list-item-styles';

type BannerListItemProps = {
  itemList: ({
    leftIcon: React.ReactNode;
    text: string;
  } & Partial<TypographyTextProps>)[];
};

export const BannerListItem: React.FC<BannerListItemProps> = ({ itemList }) => (
  <List className={bannerList}>
    {itemList?.map(({ text, leftIcon, size, variant }, index: number) => (
      <ListItem
        color="text-invert"
        columnGap={8}
        leftIcon={leftIcon}
        key={createElementKey('banner-item', index)}
        size={size || 'body_short'}
        text={text}
        variant={variant || 's'}
      />
    ))}
  </List>
);
